export class FileBase64 {
    public name: string;
    public contentType: string;
    public source: string;

    constructor(name: string = "", contentType: string = "", source: string = "") {
        this.name = name;
        this.contentType = contentType;
        this.source = source;
    }

    public download() {
        const downloadLink = document.createElement("a");
        downloadLink.href = this.source;
        downloadLink.target = "_blank";
        downloadLink.download = this.name;
        downloadLink.click();
    }


}
